<template>
  <div>
    <Header parent="balance"> 
      <template #actions>
        <BaseDatepickerInput inputClass="balance-datepicker"  ranged v-model="range"/>
      </template>
    </Header>

    <BalanceTransactionsTable 
            :transactions="transactions"
            :compact="false"/>
  </div>
</template>

<script>
import BalanceTransactionsTable from "@/components/balance/BalanceTransactionsTable.vue";

import BillingAPI from "@/api/billing"

import moment from 'moment'

export default {
  components: {
    BalanceTransactionsTable,
  },
  data() {
      return {
          transactions: [],
          range: {
            start: new Date(),
            end: new Date()
          }
      }
  },
  watch: {
    range: {
      deep: true,
      handler() {
        if (this.range.end && this.range.start) this.fetchData();
      }
    }
  },
  methods: {
      fetchData() {
          BillingAPI.getTransactions(512, moment(this.range.start).valueOf(), moment(this.range.end).valueOf()).then(data => {
              this.transactions = data.transactions;
          }).catch(err => {

          })
      }
  },
  mounted() {
    this.fetchData();
    this.range.start = moment().startOf('week').toDate();
  }
};
</script>

<style>
.balance-datepicker {
  width: 256px !important;
  min-width: 256px !important;
}
</style>